<template>
    <span class="sponsorship-content">
        {{ myResources.sponsorshipIntroLabel }}
        <template v-if="useLogo">
            <a v-if="useLink" class="sponsorship-content__logo sponsorship-content__logo--linked" :href="sponsor.url" target="_blank">
                <img class="sponsorship-content__logo__image" :src="logoPath" :alt="sponsor.name">
            </a>
            <a v-else class="sponsorship-content__logo">
                <img class="sponsorship-content__logo__image" :src="logoPath" :alt="sponsor.name">
            </a>
        </template>
        <a v-else class="sponsorship-content__link" :href="sponsor.url" target="_blank">{{ sponsor.name }}</a>
    </span>
</template>

<script>

import ResourcesHelper from '@/components/resources-helper'


export default {

    mixins: [

        ResourcesHelper,
    ],


    props: {
        showLogo: {
            type: Boolean,
            default: true,
        },
    },

    computed: {

        /**
        * @returns {AppCoreSponsorshipContentResources}
        */
        myResources() {
            return this.parseResources('components.appCore.sponsorshipContent')
        },

        /**
         * @returns {string} The path to the sponsorship logo.
         */
        logoPath() {
            return `${ this.$config.baseUrl }schemes/${ this.$scheme.path }/img/${ this.sponsor.logo }`
        },

        /**
         * @returns {SchemeSponsor|null} The sponsor object.
         */
        sponsor() {
            return this.$scheme.sponsor
        },

        /**
         * @returns {boolean} A flag to indicate if the app should use a sponsor link.
         */
        useLink() {
            return this.sponsor !== null && this.sponsor.url !== null && this.sponsor.url !== ''
        },

        /**
         * @returns {boolean} A flag to indicate if the app should use a sponsor logo.
         */
        useLogo() {
            return this.showLogo && this.sponsor !== null && this.sponsor.logo !== null
        },
    },
}

</script>


<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.
// src\scss\schemes\components\app-core\_app-sponsorship-content.scss

.sponsorship-content {
    padding: 0;
    margin: 0;

    @include element('link') {
        text-transform: none;
        cursor: pointer;
    }

    @include element('logo') {
        text-transform: none;

        @include modifier('linked') {
            cursor: pointer;
        }

        @include element('image') {
            vertical-align: middle;
        }
    }
}

</style>
